import {Component, Inject} from '@angular/core';
import {StatusGroupings} from "../../../models/api.model";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-execution-summary-dialog',
  templateUrl: './execution-summary-dialog.component.html',
  styleUrl: './execution-summary-dialog.component.scss'
})
export class ExecutionSummaryDialogComponent {
  statusGroupings: StatusGroupings
  typeMapping: {[type: string]: string } = {
    'CURRENCY_TOTALS' : 'Expense Totals Grouped by Currency',
    'ENTITY_TOTALS' : 'Expense Totals Grouped by Legal Entity',
    'CURRENCY_PAYMENT_TYPE_TOTALS' : 'Expense Totals Grouped by Currency and Payment Type',
  }

  getStatuses(): string[] {
    return Object.keys(this.statusGroupings);
  }

  getTypes(status: string): string[] {
    return Object.keys(this.statusGroupings[status]);
  }

  constructor(
    public dialogRef: MatDialogRef<ExecutionSummaryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.statusGroupings = data
  }

  onCloseClick(): void {
    this.dialogRef.close()
  }
}
